<div class="header-content">
  <div class="header__part1">
    <app-home-button></app-home-button>

    <!--    <img src="assets/images/slash.svg" alt="" />-->
    <!--    <app-logo></app-logo>-->

  </div>
  <div class="header__part2">
    <app-menu-desktop></app-menu-desktop>
    <!--    <app-user-connected></app-user-connected>-->
    <!--    <app-language-button></app-language-button>-->
  </div>
</div>
